export const AUTH_TOKEN = 'auth-token';
export const USER_ID = 'user-id';
export const USER_ROLE = 'user-role';

export const TIMELINE_EVENT_HEIGHT = 24;
export const MINIMAP_EVENT_HEIGHT = 6;
export const TIMELINE_PADDING = 32;
export const MINIMAP_PADDING = 21;
export const MINIMAP_HEIGHT = 640;
